<div class="policy bg-light">
    <div class="policy__container" [style.height.px]="appAlert.windowHeight - 200">
        <div class="policy_header">
            <h1>POLITYKA PRYWATNOŚCI  </h1>
            <h1>APLIKACJI MOBILNEJ EMODUL </h1>
        </div>
        <div class="row"></div>
        <div class="policy_navigation_menu">
            1. <a class="link" (click)="appAlert.scrollTo('Introduction')">Wprowadzenie</a>
            <br />
            2. <a class="link" (click)="appAlert.scrollTo('ContractDetails')">Informacje o Administratorze. Dane kontaktowe.</a>
            <br />
            3. <a class="link" (click)="appAlert.scrollTo('AboutEModul')">Co to jest eModul</a>
            <br />
            4. <a class="link" (click)="appAlert.scrollTo('AboutPolicy')">Informacje na temat polityki bezpieczeństwa</a>
            <br />
            5. <a class="link" (click)="appAlert.scrollTo('DataCollection')">Dane, które zbieramy. Sposób gromadzenia danych.</a>
            <br />
            6. <a class="link" (click)="appAlert.scrollTo('DataUsage')">Sposób przetwarzania danych</a>
            <br />
            7. <a class="link" (click)="appAlert.scrollTo('YourRights')">Twoje uprawnienia związane z przetwarzaniem danych</a>
            <br />
            8. <a class="link" (click)="appAlert.scrollTo('StoringData')">Przechowywanie danych</a>
            <br />
            9. <a class="link" (click)="appAlert.scrollTo('SharingData')">Udostępnianie danych. Przesyłanie danych do krajów trzecich.</a>
        </div>
        <div class="policy_body>">
            <div class="policy_paragraph">
                <h1 id="Introduction">1. WPROWADZENIE </h1>
                <p class="content">
                    Dziękujemy za wybranie aplikacji eModul! Dokładamy najwyższej staranności, by eModul spełnił wszystkie Twoje oczekiwania, dlatego jednym z naszych najwyższych
                    priorytetów jest Twoja prywatność i bezpieczeństwo danych, które nam przekazujesz. W celu ich zapewnienia ustanowiliśmy dokument, który nazwaliśmy Polityką Prywatności
                    Aplikacji Mobilnej eModul. Prosimy Cię o szczegółowe zapoznanie się z Polityką przed przystąpieniem do korzystania z eModul.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="ContractDetails">2. INFORMACJE O ADMINISTRATORZE EMODUL. DANE KONTAKTOWE </h1>
                <p class="content">
                    eModul jest aplikacją stworzoną i administrowaną przez TECH STEROWNIKI spółka z ograniczoną odpowiedzialnością  spółka komandytowa z siedzibą w Wieprzu,
                    ul. Biała Droga 31, 34-122 Wieprz, NIP 551 23 60 632, REGON 356782780, KRS 0000594881. Zachęcamy Cię do kontaktu we wszelkich sprawach, które są dla Ciebie istotne.
                    Można się z nami skontaktować:
                </p>
                <table class="policy_contact_details_table">
                    <tr>
                        <td>Mailowo </td>
                        <td>poczta&#64;techsterowniki.pl </td>
                    </tr>
                    <tr class="separating_line">
                        <td>Pisemnie </td>
                        <td>ul. Biała Droga 31, 34-122 Wieprz </td>
                    </tr>
                    <tr class="separating_line">
                        <td>Telefonicznie  </td>
                        <td>+48 33 330 00 07 </td>
                    </tr>
                </table>
            </div>

            <div class="policy_paragraph">
                <h1 id="AboutEModul">3. CO TO JEST EMODUL</h1>
                <h2>3.1</h2>
                <p class="content">
                    eModul jest aplikacją dedykowaną do obsługi sterowników współpracujących z modułami z rodziny  ST-505 oraz Wi-Fi. Korzystając z eModul możesz:
                </p>
                <ul class="pp_list">
                    <li>uzyskać podgląd do wszystkich aktualnych parametrów sterownika oraz edytować te parametry; </li>
                    <li>uzyskać podgląd do historii temperatur oraz alarmów;  </li>
                    <li>ontrolować wiele modułów z jednego konta; a także  </li>
                    <li>otrzymywać mailowe powiadomienie o aktualnych alarmach.</li>
                </ul>
            </div>

            <div class="policy_paragraph">
                <h2>3.2</h2>
                <p class="content">
                    Korzystanie z eModul jest nieodpłatne, przy czym wymaga posiadania sterowników współpracujących z ww. modułami. Wszystkie dane, które nam przekazujesz są danymi
                    służącymi prawidłowemu funkcjonowaniu eModul, celom statystycznym oraz celom związanym z usprawnieniem działania eModul. eModul przeznaczona jest dla osób powyżej
                    13. roku życia.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="AboutPolicy">4. INFORMACJE NA TEMAT POLITYKI </h1>
                <h2>4.1</h2>
                <p class="content">
                    W Polityce zawarto wszystkie niezbędne informacje, które regulują nasze relacje dotyczące przekazywanych przez Ciebie informacji. Tym samym, podstawowym celem Polityki jest:
                </p>
                <ul class="pp_list">
                    <li>zapewnienie tego, że na każdym etapie naszej współpracy będziesz wiedział, jakie dane od Ciebie zbieramy, co z nimi robimy i jakie masz w związku z tym uprawnienia; </li>
                    <li>zapewnienie tego, że Twoja zgoda na przekazanie nam danych jest zawsze świadoma i dobrowolna.</li>
                </ul>
            </div>

            <div class="policy_paragraph">
                <h2>4.2</h2>
                <p class="content">
                    Stale rozwijajmy i ulepszamy eModul, dlatego jeśli będziemy dokonywać zmian w aplikacji, które wpływać będą na zakres gromadzenia i przetwarzania podawanych przez Ciebie
                    danych przekażemy Ci dodatkowe informacje, warunki lub zasady. Jeśli nowy zakres gromadzenia i przetwarzania nie będzie zgodny z Twoimi preferencjami zawsze będziesz mógł
                    nie wyrazić na nie zgody, co jednak może wiązać się z wyłączeniem eModul na Twoim urządzeniu.
                </p>
            </div>

            <div class="policy_paragraph">
                <h2>4.3</h2>
                <p class="content">
                    Pomimo braku zmian w eModul okresowo możemy zmieniać samą Politykę. W przypadku takich zmian poinformujemy Cię o nich w jasny i jednoznaczny sposób
                    (np. poprzez wiadomość email). Wszelkie zmiany Polityki będą wchodzić w życie w czasie, który umożliwi Ci swobodne podjęcie decyzji o tym, czy dalej chcesz korzystać z
                    eModul pomimo implementowanych zmian.                 </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="DataCollection">5. DANE, KTÓRE ZBIERAMY. SPOSÓB GROMADZENIA DANYCH</h1>
                <h2>5.1</h2>
                <p class="content">
                    Poniżej wyszczególniliśmy dane, które od Ciebie zbieramy na każdym etapie interakcji z eModul:
                </p>
                <table class="policy_details_table">
                    <tr>
                        <th>Etap  </th>
                        <th>Kategoria  </th>
                        <th>Opis  </th>
                    </tr>

                    <tr>
                        <td>Rejestracja   </td>
                        <td>Dane rejestracji  </td>
                        <td>
                            <p>Są to wszystkie dane, które podajesz nam w procesie rejestracji w eModul. Warunkiem ich zbierania jest to, że dobrowolnie wprowadzisz je w eModul.</p>
                            <p>Daną, którą od Ciebie pozyskujemy na tym etapie jest: adres email do weryfikacji rejestracji konta. </p>
                        </td>
                    </tr>

                    <tr>
                        <td>Rejestracja modułu </td>
                        <td>Dane rejestracji szczegółowej </td>
                        <td>
                            <p>Są to wszystkie dane, które podajesz nam w procesie rejestracji zakupionego modułu. Warunkiem ich zbierania jest to, że dobrowolnie wprowadzisz je w eModul. </p>
                            <p>Danymi, które od Ciebie pozyskujemy na tym etapie są: adres email do wysyłania powiadomień (może być ten sam, co podawany w procesie rejestracji), telefon do wysyłania powiadomień</p>
                            <p>W procesie rejestracji modułu możesz podać nam dane dodatkowe, dzięki którym Twoje konto w eModul będzie bardziej spersonalizowane. W szczególności, prosimy Cię o podanie kodu pocztowego
                                oraz kraju, przy czym podanie tych danych nie jest konieczne dla ukończenia rejestracji szczegółowej. </p>
                        </td>
                    </tr>
                    <tr>
                        <td>Korzystanie z eModul </td>
                        <td>Dane korzystania </td>
                        <td>
                            <p>Są to wszystkie dane, które pozyskujemy od Ciebie w sposób zautomatyzowany, w czasie w którym korzystasz z eModul.</p>
                            <p>Danymi, które od Ciebie pozyskujemy na tym etapie są: nazwa urządzenia, unikalny token urządzenia (wykorzystywany dla potrzeb powiadomień), wersja oprogramowania urządzenia, kraj instalacji
                                eModul oraz informacje o ewentualnych błędach generowanych przez eModul.</p>
                            <p>eModul w wersji przeglądarkowej korzysta też z plików cookies, które wykorzystywane są wyłącznie dla celów podtrzymania logowania (sesji). </p>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="policy_paragraph">
                <h2>5.2</h2>
                <p class="content">
                    Wszystkie zbierane przez nas dane, które są podawane przez Ciebie w procesie rejestracji modułu, podawane są dobrowolnie. Dane zbierane automatycznie pozwalają nam zaś na ulepszanie eModul.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="DataUsage">6. SPOSÓB KORZYSTANIA Z DANYCH  </h1>
                <h2>6.1</h2>
                <p class="content">
                    Poniżej wyszczególniliśmy sposoby, na które wykorzystujemy zbierane od Ciebie dane
                </p>
                <table class="policy_details_table">
                    <tr>
                        <th>Kategoria  </th>
                        <th>Podstawa   </th>
                        <th>Powody przetwarzania  </th>
                    </tr>

                    <tr>
                        <td>Dane rejestracji </td>
                        <td>Realizacja umowy </td>
                        <td> Dane te są niezbędne dla wykonania umowy zawieranej z Tobą wraz z zalogowaniem się przez Ciebie w eModul. Umowa ta dotyczy utworzenia konta w eModul,
                            w którym możliwe jest zarejestrowanie sterownika.    </td>
                    </tr>
                    <tr>
                        <td>Dane rejestracji szczegółowej </td>
                        <td>Realizacja umowy  </td>
                        <td>
                            Dane te są niezbędne dla wykonania umowy zawieranej z Tobą wraz z zalogowaniem się przez Ciebie w eModul. Umowa ta dotyczy udostępnienia przez nas
                            funkcjonalności eModul opisanych w punkcie 3 Polityki.
                        </td>
                    </tr>
                    <tr>
                        <td>Dane rejestracji szczegółowej </td>
                        <td>Performance of the agreement  </td>
                        <td>
                            Dane te są niezbędne do komunikowania się z Tobą w zawiązku z alarmami pojawiającymi się w modułach.
                        </td>
                    </tr>

                    <tr>
                        <td>Dane rejestracji szczegółowej </td>
                        <td>Twoja zgoda </td>
                        <td>
                            W rejestracji szczegółowej możesz podać nam dane dodatkowe, w tym kod pocztowy i kraj. Dane te wykorzystujemy dla celów statystycznych oraz dla celów związanych z
                            usprawnieniem działania eModul.
                        </td>
                    </tr>

                    <tr>
                        <td>Dane korzystania  </td>
                        <td>Realizacja umowy  <br/> <br/>Uzasadnione interesy  </td>
                        <td>
                            Dane te wykorzystujemy dla celów statystycznych oraz dla celów związanych z usprawnieniem działania eModul.
                        </td>
                    </tr>
                </table>
            </div>

            <div class="policy_paragraph">
                <h2>6.2</h2>
                <p class="content">
                    Nigdy nie korzystamy z danych uzyskanych od Ciebie do podejmowania decyzji w sposób automatyczny, w tym profilowania, jeśli dana decyzja może powodować dla Ciebie skutki prawne lub mieć podobny efekt.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="YourRights">7. TWOJE UPRAWNIENIA ZWIĄZANE ZE ZBIERANIEM DANYCH</h1>
                <h2>7.1</h2>
                <p class="content">
                    W związku z tym, że przekazujesz nam swoje dane, w tym dane osobowe, przysługuje Ci szereg uprawnień. Pamiętaj zatem, że w każdym czasie przysługuje Ci:
                </p>
                <table class="policy_details_table_no_header">
                    <tr>
                        <td>Prawo dostępu </td>
                        <td>prawo do bycia informowanym oraz żądania dostępu do przetwarzanych przez nas danych. </td>
                    </tr>
                    <tr>
                        <td>Prawo sprostowania   </td>
                        <td>prawo do żądania poprawienia lub zaktualizowania danych, jeśli są one niedokładne lub niepełne. </td>
                    </tr>
                    <tr>
                        <td>Prawo do usunięcia  </td>
                        <td>prawo do żądania usunięcia danych.</td>
                    </tr>

                    <tr>
                        <td>Prawo do ograniczenia </td>
                        <td>prawo do żądania zaprzestania przez nas tymczasowo lub na stałe przetwarzania wszystkich lub części danych.  </td>
                    </tr>

                    <tr>
                        <td>Prawo sprzeciwu </td>
                        <td>prawo do sprzeciwu, w dowolnym momencie, wobec przetwarzania przez nas danych z przyczyn odnoszących się do konkretnych sytuacji.</td>
                    </tr>
                    <tr>
                        <td>Prawo do przenoszenia  </td>
                        <td>prawo do zażądania kopii elektronicznej danych lub przekazania ich w celu wykorzystania przez strony trzecie. </td>
                    </tr>
                    <tr>
                        <td>Prawo skargi  </td>
                        <td>prawo zgłoszenia skargi na przetwarzanie danych osobowych do organu nadzoru, którym w Polsce jest Prezes Urzędu Ochrony Danych osobowych. </td>
                    </tr>
                </table>
                <h2>7.2</h2>
                <p>
                    Wszystkie przysługujące Ci uprawnienia realizować możesz w drodze kontaktu, zgodnie z danymi podanymi w punkcie 2 Polityki.
                </p>
            </div>
            <div class="policy_paragraph">
                <h1 id="StoringData">8. PRZECHOWYWANIE DANYCH </h1>
                <h2>8.1</h2>
                <p class="content">
                    Twoje dane, które przetwarzamy w związku z realizacją umowy oraz na podstawie uzasadnionego interesu, przechowujemy tak długo, jak jest to konieczne,
                    aby zapewnić Ci korzystanie z eModul, oraz w uzasadnionych i koniecznych celach, wywiązywanie się ze zobowiązań prawnych oraz rozstrzyganie konfliktów.
                    Twoje dane będą przechowywane tak długo, jak długo będziesz korzystać z eModul, przez co rozumiemy sytuację, w której zgłosisz nam chęć usunięcia swojego konta.
                    Po zaprzestaniu korzystania z eModul Twoje dane będą przez nas przechowywane przez okres przedawnienia ewentualnych roszczeń.
                </p>
            </div>

            <div class="policy_paragraph">
                <h2>8.2</h2>
                <p class="content">
                    Twoje dane, które przetwarzamy na podstawie dobrowolnej zgody przechowujemy tak długo, jak długo nie odwołasz swojej zgody. By odwołać zgodę wystarczy skorzystać z funkcjonalność eModul
                    lub zgłosić nam chęć usunięcia swojego konta.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="SharingData">9. UDOSTĘPNIANIE DANYCH. PRZESYŁANIE DANYCH DO KRAJÓW TRZECICH  </h1>
                <h2>9.1</h2>
                <p class="content">
                    Twoje dane mogą być udostępniane wyłącznie w sytuacjach, w których prawo na to zezwala. Na chwilę obecną przewidujemy udostępnienie tych danych wyłącznie na podstawie umowy powierzenia przetwarzania na rzecz:
                </p>
                <ul class="pp_list">
                    <li>obsługi infrastruktury informatycznej oraz systemów informatycznych;  </li>
                    <li>podwykonawców pomagającym nam prawidłowo realizować nasze zobowiązania. </li>
                </ul>
            </div>
            <div class="policy_paragraph">
                <h2>9.2</h2>
                <p class="content">
                    Twoje dane nie są przesyłane do krajów spoza Europejskiego Obszaru Gospodarczego.
                </p>
            </div>
        </div>
    </div>

    <div class="policy__buttons-box">
        <input type="button"
               [value]="subtitles.setSubtitle(1744)"
               class="app-alert__button  bg-ok color-light font-bold font-14 cursor-pointer"
               (click)="appAlert.closePolicy()">
    </div>

</div>
